// Poster placeholders — user will upload real film posters later
const POSTERS = {
  arjun: "https://images.unsplash.com/photo-1585608996900-c8d3a49328a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxhbmNpZW50JTIwYXJjaGVyJTIwZGFyayUyMHNpbGhvdWV0dGUlMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzg1NTk3NTMzfDA&ixlib=rb-4.1.0&q=85",
  temple: "https://images.unsplash.com/photo-1674033846163-fe3ea31c1f97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxteXN0aWNhbCUyMGZvcmVzdCUyMHRlbXBsZSUyMGRhcmslMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzg1NTk3NTMyfDA&ixlib=rb-4.1.0&q=85",
  buddha: "https://images.unsplash.com/photo-1724154353955-525f6e738c0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxidWRkaGElMjBzaWxob3VldHRlJTIwZ29sZGVuJTIwbGlnaHQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODU1OTc1MzJ8MA&ixlib=rb-4.1.0&q=85",
  cave: "https://images.unsplash.com/photo-1482424917728-d82d29662023?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbXlzdGljYWwlMjBjYXZlJTIwc21va2UlMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzg1NTk3NTMyfDA&ixlib=rb-4.1.0&q=85",
  set: "https://images.unsplash.com/photo-1727451139462-cd34008cd50b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBmaWxtJTIwc2V0JTIwZGFyayUyMG1vb2R5JTIwbGlnaHRpbmd8ZW58MHx8fHwxNzg1NTk3NTMyfDA&ixlib=rb-4.1.0&q=85",
  himalaya: "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&q=85&w=1400",
  monastery: "https://images.unsplash.com/photo-1526392060635-9d6019884377?auto=format&fit=crop&q=85&w=1400",
  snow: "https://images.unsplash.com/photo-1483347756197-71ef80e95f73?auto=format&fit=crop&q=85&w=1400",
  river: "https://images.unsplash.com/photo-1470770903676-69b98201ea1c?auto=format&fit=crop&q=85&w=1400",
  festival: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&q=85&w=1400",
  yak: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=85&w=1400",
  border: "https://images.unsplash.com/photo-1516569422572-3b1cea6bdaa4?auto=format&fit=crop&q=85&w=1400",
};

export const STATUSES = {
  COMPLETED: "Completed",
  DEVELOPED: "Developed",
  IN_PRODUCTION: "In Production",
  ON_THE_FLOOR: "On the Floor",
  CONCEPT: "Concept Development",
};

// Consistent producer team applied across the slate
const CORE_PRODUCERS = "Rajendra Bhandari (Executive Producer), Neha Agarwal & Milan Chaudhary (Producers)";

export const FILMS = [
  // ── COMPLETED WORKS ───────────────────────────────────────────────
  {
    slug: "sagarmatha-ko-bishwas",
    title: "Sagarmatha Ko Bishwas",
    nepaliTitle: "सगरमाथाको विश्वास",
    hindiTitle: "सगरमाथा का विश्वास",
    genre: "Cultural & Spiritual Short Documentary",
    year: "2020",
    status: STATUSES.COMPLETED,
    runtime: "26 min",
    language: "Nepali / Sherpa",
    poster: POSTERS.himalaya,
    shortSynopsis: "The studio's founding-year documentary — a short film on Sherpa spirituality, prayer flags and the mountain that is worshipped, not conquered.",
    synopsis: "Filmed at the foot of Sagarmatha (Mount Everest), this short documentary follows the Sherpa families of the Khumbu valley as they light butter lamps, hoist prayer flags and speak of the mountain as a mother, not a peak. The studio's first release — Sagarmatha Ko Bishwas set the tone for everything that followed: patience, reverence, and a camera that listens.",
    director: "Sushil K C",
    writer: "Bhuwan Acharya",
    dop: "Srijana Shrestha",
    producers: CORE_PRODUCERS,
    festivals: ["Kathmandu International Mountain Film Festival 2021 — Screening"],
    cast: [
      { name: "Sushil K C", role: "Director" },
      { name: "Bhuwan Acharya", role: "Writer" },
      { name: "Srijana Shrestha", role: "Cinematographer" },
    ],
  },
  {
    slug: "pathibhara-aama-ko-aawaz",
    title: "Pathibhara: Aama Ko Aawaz",
    nepaliTitle: "पाथीभरा: आमाको आवाज",
    hindiTitle: "पाथीभरा: माँ की आवाज़",
    genre: "Cultural & Spiritual Short Documentary",
    year: "2019",
    status: STATUSES.COMPLETED,
    runtime: "28 min",
    language: "Nepali / Limbu",
    poster: POSTERS.temple,
    shortSynopsis: "A short documentary honouring the sacred hill-goddess Pathibhara and the voices of the eastern Himalayan communities who carry her name.",
    synopsis: "Filmed across the shrines and trails of Taplejung, Pathibhara: Aama Ko Aawaz listens to the pilgrims, priests and mothers of eastern Nepal as they speak of Pathibhara Devi — the mountain-goddess whose blessing draws devotees across borders. A short documentary about faith, matriarchy and the quiet endurance of a place where the earth itself is prayed to.",
    director: "Sushil K C",
    writer: "Bhuwan Acharya",
    dop: "Srijana Shrestha",
    producers: CORE_PRODUCERS,
    festivals: ["Nepal International Indigenous Film Festival 2019 — Screening", "Kathmandu International Mountain Film Festival 2020 — Screening"],
    cast: [
      { name: "Sushil K C", role: "Director" },
      { name: "Bhuwan Acharya", role: "Writer" },
      { name: "Srijana Shrestha", role: "Cinematographer" },
    ],
  },
  {
    slug: "maato-ra-sanskriti",
    title: "Maato Ra Sanskriti",
    nepaliTitle: "माटो र संस्कृति",
    hindiTitle: "मिट्टी और संस्कृति",
    genre: "Cultural Short Film",
    year: "2021",
    status: STATUSES.COMPLETED,
    runtime: "22 min",
    language: "Nepali",
    poster: POSTERS.set,
    shortSynopsis: "Soil and culture — a lyrical short film about the potters, farmers and ritual-keepers whose hands still shape the everyday sacred of rural Nepal.",
    synopsis: "Maato Ra Sanskriti (‘Soil and Culture’) is a short cinematic essay on the artisans of Bhaktapur and the Terai — potters, weavers, festival makers — whose work sits at the meeting-point of daily livelihood and inherited ritual. A meditation on the tactile intelligence of a country that still knows how to make things by hand.",
    director: "Bhim Bahadur Gautam",
    writer: "Bhuwan Acharya",
    dop: "Srijana Shrestha",
    producers: CORE_PRODUCERS,
    festivals: ["South Asian Short Film Forum 2021 — Screening", "Ekadeshma International Film Festival 2022 — Screening"],
    cast: [
      { name: "Bhim Bahadur Gautam", role: "Director" },
      { name: "Bhuwan Acharya", role: "Writer" },
      { name: "Srijana Shrestha", role: "Cinematographer" },
    ],
  },
  {
    slug: "purba-ko-ganga",
    title: "Purba Ko Ganga",
    nepaliTitle: "पूर्वको गंगा",
    hindiTitle: "पूरब की गंगा",
    genre: "Environmental & Cultural Documentary",
    year: "2022",
    status: STATUSES.COMPLETED,
    runtime: "34 min",
    language: "Nepali / Rai / Limbu",
    poster: POSTERS.river,
    shortSynopsis: "The Ganga of the East — a documentary tracing the Tamor and Koshi rivers as they carry culture, commerce and memory from the Himalayas to the plains.",
    synopsis: "Purba Ko Ganga follows the Tamor and Koshi river-systems across eastern Nepal — from glacial headwaters to the border ghats — through the lives of the fishermen, farmers, boat-builders and pujaris who depend on these waters. A documentary about ecology, migration and the sacred geography of rivers.",
    director: "Sushil K C",
    writer: "Bhim Bahadur Gautam",
    dop: "Srijana Shrestha",
    producers: CORE_PRODUCERS,
    festivals: ["Kathmandu International Mountain Film Festival 2022 — Screening", "Film Southasia 2023 — Screening", "Nepal Human Rights International Film Festival 2023 — Screening"],
    cast: [
      { name: "Sushil K C", role: "Director" },
      { name: "Bhim Bahadur Gautam", role: "Writer" },
      { name: "Srijana Shrestha", role: "Cinematographer" },
      { name: "Diwas Rai", role: "Music Director" },
    ],
  },
  {
    slug: "kalash-ko-sangeet",
    title: "Kalash Ko Sangeet",
    nepaliTitle: "कलशको सङ्गीत",
    hindiTitle: "कलश का संगीत",
    genre: "Cultural & Musical Short Documentary",
    year: "2023",
    status: STATUSES.COMPLETED,
    runtime: "24 min",
    language: "Nepali / Newa",
    poster: POSTERS.festival,
    shortSynopsis: "Music of the sacred vessel — a short documentary on the last families of the Kathmandu Valley still crafting the ritual instruments that carry a festival's soul.",
    synopsis: "Kalash Ko Sangeet is a short documentary about the Newar dhime, ponga and jhyali musicians who accompany every festival in the Kathmandu Valley — and the ageing craftsmen who still handmake their instruments in courtyards behind the temples. A film about the sound of a tradition that must be played to stay alive.",
    director: "Bhim Bahadur Gautam",
    writer: "Bhuwan Acharya",
    dop: "Srijana Shrestha",
    producers: CORE_PRODUCERS,
    festivals: ["Film Southasia 2023 — Screening", "Nepal International Indigenous Film Festival 2024 — Screening"],
    cast: [
      { name: "Bhim Bahadur Gautam", role: "Director" },
      { name: "Bhuwan Acharya", role: "Writer" },
      { name: "Srijana Shrestha", role: "Cinematographer" },
      { name: "Diwas Rai", role: "Music Director" },
    ],
  },
  {
    slug: "rato-machhindranath",
    title: "Rato Machhindranath",
    nepaliTitle: "रातो मच्छिन्द्रनाथ",
    hindiTitle: "रातो मच्छिन्द्रनाथ",
    genre: "Cultural Heritage Documentary",
    year: "2024",
    status: STATUSES.COMPLETED,
    runtime: "28 min",
    language: "Nepali / Newa",
    poster: POSTERS.cave,
    shortSynopsis: "A short documentary on the great red-chariot festival of Rato Machhindranath — the Kathmandu Valley's longest-running rain-god procession.",
    synopsis: "Rato Machhindranath tracks the annual month-long chariot festival that carries the red god of rain from Pulchowk to Bungmati and back — the oldest continuously observed festival in the Kathmandu Valley. Through the eyes of the Guthi priests, the wheelwrights and the crowds who pull the tower-chariot down narrow streets, the film asks what it takes to keep a festival alive for more than a thousand years.",
    director: "Sushil K C",
    writer: "Bhuwan Acharya",
    dop: "Srijana Shrestha",
    producers: CORE_PRODUCERS,
    festivals: ["Kathmandu International Mountain Film Festival 2024 — Screening"],
    cast: [
      { name: "Sushil K C", role: "Director" },
      { name: "Bhuwan Acharya", role: "Writer" },
      { name: "Srijana Shrestha", role: "Cinematographer" },
      { name: "Diwas Rai", role: "Music Director" },
    ],
  },

  // ── DEVELOPED FEATURES ────────────────────────────────────────────
  {
    slug: "eternal-flow-arrow-of-arjun",
    title: "Eternal Flow: The Arrow of Arjun",
    nepaliTitle: "अर्जुनको बाण",
    hindiTitle: "अर्जुन का बाण",
    genre: "Historical, Spiritual and Cultural Drama",
    year: "2026",
    status: STATUSES.DEVELOPED,
    runtime: "128 min",
    language: "Nepali / Sanskrit",
    poster: POSTERS.arjun,
    tagline: "In the sacred land of Arjunadhara Jaleshwar Dham.",
    shortSynopsis: "A living dham where Arjuna's arrow of compassion still runs as an eternal stream — quenching the spiritual, cultural and social thirst of thousands, day and night.",
    synopsis: "In the sacred land of Arjunadhara Jaleshwar Dham, an ancient legend comes alive. Just as Arjuna shot an arrow of compassion to create a life-giving stream for the thirsty cows of the Mahabharata, this living dham continues to quench the spiritual, cultural and social thirst of thousands even today.\n\nMore than a temple, Arjunadhara Jaleshwar Dham stands as a vibrant heart of a community — where faith flows like an eternal river. From grand Mahashivratri celebrations and the month-long Shravani Parva to the deeply emotional Bala Chaturdashi, the dham pulses with devotion day and night.\n\nHere, ancient values meet modern life: free education for poor and Dalit students, a working goshala, yagyas and inclusive service prove that true faith knows no discrimination. Drone views reveal vast green surroundings, an ancient pond and a majestic temple complex. Outside the main gate, rows of puja shops buzz with life — providing livelihood to local families and showing how compassion extends beyond rituals into daily existence.\n\nThis is not merely a place of worship. It is a living testimony that one arrow of kindness can sustain life for thousands of years. Eternal Flow: The Arrow of Arjun is a journey into a sacred space where history, spirituality, culture and community flow together — reminding us that faith and compassion never dry up.",
    director: "Sushil K C",
    writer: "Bhuwan Acharya",
    dop: "Srijana Shrestha",
    producers: CORE_PRODUCERS,
    festivals: ["TIFF: The Market 2026 — Market Participation Objective"],
    cast: [
      { name: "Sushil K C", role: "Director" },
      { name: "Bhuwan Acharya", role: "Writer / Screenwriter" },
      { name: "Srijana Shrestha", role: "Cinematographer" },
    ],
  },
  {
    slug: "threads-of-faith-budha-subba",
    title: "Threads of Faith: The Budha Subba Story",
    nepaliTitle: "बुढासुब्बाको कथा",
    hindiTitle: "बुढा सुब्बा की गाथा",
    genre: "Cultural, Spiritual and Heritage Documentary",
    year: "2026",
    status: STATUSES.DEVELOPED,
    runtime: "116 min",
    language: "Nepali / Limbu",
    poster: POSTERS.temple,
    tagline: "Where bamboos have no tips.",
    shortSynopsis: "Nestled on a lush hilltop above Dharan, Budha Subba is a wish-fulfilling shrine where myth, history and prayer intertwine — and where every bamboo mysteriously grows without a tip.",
    synopsis: "Nestled on a lush hilltop overlooking Dharan in eastern Nepal, Budha Subba Temple is a living shrine where myth, history and fervent wishes intertwine. This evocative documentary explores a sacred site revered by thousands as a powerful wish-fulfilling deity.\n\nAt its heart lie two earthen mounds worshipped as Budha Subba — believed to be the resting place of Buddhi Karna Raya, the last Limbu king of the region, whose reign ended during Nepal's 18th-century unification. His spirit is said to still watch over the land, granting success in love, in career and in life.\n\nThe film delves into the temple's most enchanting mystery: the surrounding bamboo grove where every stalk grows without a tip. Through rich local legends — from a remorseful hunter's slingshot to divine visits by Shiva and Parvati — the documentary uncovers why this place feels truly magical.\n\nBlending stunning visuals of colourful prayer threads fluttering in the wind, devotee rituals and panoramic Himalayan foothills, Threads of Faith reveals a unique fusion of Kirat ancestral worship, Hindu devotion and living folklore. A story of tragedy, resilience, faith and hope — where the past still answers the prayers of the present.",
    director: "Bhim Bahadur Gautam",
    writer: "Bhim Bahadur Gautam",
    dop: "Kartik Vijay",
    producers: CORE_PRODUCERS,
    festivals: ["TIFF: The Market 2026 — Market Participation Objective"],
    cast: [
      { name: "Bhim Bahadur Gautam", role: "Creative Director" },
      { name: "Diwas Rai", role: "Music Director" },
      { name: "Kul Bahadur Karki", role: "Production Manager" },
    ],
  },
  {
    slug: "the-buddha-hidden-truth",
    title: "The Buddha – Hidden Truth",
    nepaliTitle: "बुद्ध – लुकेको सत्य",
    hindiTitle: "बुद्ध – छिपा हुआ सत्य",
    genre: "Historical and Spiritual Documentary",
    year: "2027",
    status: STATUSES.DEVELOPED,
    runtime: "140 min (planned)",
    language: "Pali / Nepali / Hindi",
    poster: POSTERS.buddha,
    shortSynopsis: "An insightful cinematic exploration of the lesser-known history, teachings and global legacy of Lord Buddha.",
    synopsis: "Before the enlightenment, before the name, before the myth — there was a young prince who walked out of a palace and into history. An insightful cinematic exploration of the lesser-known history, teachings and global legacy of Lord Buddha, tracing footprints from Lumbini through Bodh Gaya to the far edges of the Silk Road.",
    director: "Kamal Mani Nepal",
    writer: "Sudip Sharma",
    dop: "Ravi Krishnan",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Kamal Mani Nepal", role: "Director" },
      { name: "Sudip Sharma", role: "Writer" },
      { name: "Ravi Krishnan", role: "Cinematographer" },
      { name: "Sushil K C", role: "Creative Advisor" },
      { name: "Bhuwan Acharya", role: "Story Consultant" },
      { name: "Rakesh Adhikari", role: "Research Head" },
      { name: "Deepak Rimal", role: "Story Editor" },
      { name: "Sneha Joshi", role: "Costume Designer" },
      { name: "Roshni Yadav", role: "Wardrobe Supervisor" },
      { name: "Priyanka Basnet", role: "Motion Graphics" },
      { name: "Anita Ghimire", role: "Publicity & Festivals" },
      { name: "Manoj Karki", role: "Screenings Coordinator" },
    ],
  },
  {
    slug: "halesi-dham-mahadev-hides",
    title: "Halesi Dham – Where Mahadev Hides",
    nepaliTitle: "हलेसी धाम – जहाँ महादेव लुक्छन्",
    hindiTitle: "हलेसी धाम – जहाँ महादेव छिपे हैं",
    genre: "Spiritual Journey and Sacred Heritage",
    year: "2027",
    status: STATUSES.DEVELOPED,
    runtime: "118 min (planned)",
    language: "Nepali",
    poster: POSTERS.cave,
    shortSynopsis: "A spiritual and visual journey into the sacred caves, legends, history and divine atmosphere of Halesi Dham.",
    synopsis: "Deep within the caves of Halesi Mahadevsthan, three faiths — Kirant, Hindu, Buddhist — braid into a single hymn of stone and shadow. A spiritual and visual journey into the sacred caves, legends, history and divine atmosphere of Halesi Dham.",
    director: "Bikash Rana Magar",
    writer: "Priya Malhotra",
    dop: "Bijay Limbu",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Bikash Rana Magar", role: "Director" },
      { name: "Priya Malhotra", role: "Writer" },
      { name: "Bijay Limbu", role: "Cinematographer" },
      { name: "Bhuwan Acharya", role: "Story Consultant" },
      { name: "Rakesh Adhikari", role: "Research Head" },
      { name: "Meera Pradhan", role: "Location Manager" },
      { name: "Srijana Shrestha", role: "Additional Cinematography" },
      { name: "Bikash Maharjan", role: "Set Decorator" },
    ],
  },
  {
    slug: "echoes-of-mustang",
    title: "Echoes of Mustang",
    nepaliTitle: "मुस्ताङका प्रतिध्वनिहरू",
    hindiTitle: "मुस्तांग की गूंज",
    genre: "Himalayan Cultural Drama",
    year: "2027",
    status: STATUSES.DEVELOPED,
    runtime: "124 min (planned)",
    language: "Nepali / Loba",
    poster: POSTERS.himalaya,
    shortSynopsis: "A visually rich story about memory, migration, family and the changing traditions of Nepal's Himalayan communities.",
    synopsis: "A visually rich story about memory, migration, family and the changing traditions of Nepal's Himalayan communities. Set against the wind-carved cliffs of Upper Mustang, three generations grapple with what stays and what is carried away when a valley learns a new language.",
    director: "Nabin Subedi",
    writer: "Sushil K C",
    dop: "Aarav Iyer",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Nabin Subedi", role: "Director" },
      { name: "Sushil K C", role: "Writer" },
      { name: "Aarav Iyer", role: "Cinematographer" },
      { name: "Rakesh Adhikari", role: "Research Head" },
      { name: "Meera Pradhan", role: "Location Manager" },
      { name: "Srijana Shrestha", role: "Additional Cinematography" },
      { name: "Prashant Thapa", role: "Drone Operator" },
    ],
  },
  {
    slug: "last-shaman-himalayas",
    title: "The Last Shaman of the Himalayas",
    nepaliTitle: "हिमालको अन्तिम धामी",
    hindiTitle: "हिमालय का अंतिम शमन",
    genre: "Indigenous Culture and Spiritual Mystery",
    year: "2027",
    status: STATUSES.DEVELOPED,
    runtime: "122 min (planned)",
    language: "Nepali / Tamang",
    poster: POSTERS.monastery,
    shortSynopsis: "An emotional journey following an aging spiritual healer struggling to preserve ancestral knowledge in a rapidly changing world.",
    synopsis: "An emotional journey following an aging spiritual healer struggling to preserve ancestral knowledge in a rapidly changing world. Between drum, chant, and mobile signal, a village asks a question older than the mountain: who remembers the songs when the last singer sleeps?",
    director: "Sameer Prasad Chhetri",
    writer: "Neha Agarwal",
    dop: "Kartik Vijay",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Sameer Prasad Chhetri", role: "Director" },
      { name: "Neha Agarwal", role: "Writer" },
      { name: "Kartik Vijay", role: "Cinematographer" },
      { name: "Deepak Rimal", role: "Story Editor" },
      { name: "Srijana Shrestha", role: "Additional Cinematography" },
      { name: "Alisha Karki", role: "Second Unit DoP" },
      { name: "Sneha Joshi", role: "Costume Designer" },
      { name: "Kavita Rai", role: "Makeup & Hair" },
    ],
  },
  {
    slug: "river-of-forgotten-songs",
    title: "River of Forgotten Songs",
    nepaliTitle: "बिर्सिएका गीतहरूको नदी",
    hindiTitle: "भूले हुए गीतों की नदी",
    genre: "Musical and Cultural Drama",
    year: "2027",
    status: STATUSES.DEVELOPED,
    runtime: "115 min (planned)",
    language: "Nepali",
    poster: POSTERS.river,
    shortSynopsis: "A moving story about a young musician who travels across rural Nepal to rediscover forgotten folk songs and reconnect with family history.",
    synopsis: "A moving story about a young musician who travels across rural Nepal to rediscover forgotten folk songs and reconnect with family history. A road-map of madal beats, half-remembered lullabies, and the quiet dignity of grandmothers who still know all the verses.",
    director: "Milan Chaudhary",
    writer: "Ritika Verma",
    dop: "Ravi Krishnan",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Milan Chaudhary", role: "Director" },
      { name: "Ritika Verma", role: "Writer" },
      { name: "Ravi Krishnan", role: "Cinematographer" },
      { name: "Diwas Rai", role: "Music Director" },
      { name: "Anita Sharma", role: "Dialogue Writer" },
      { name: "Saraswati Devi", role: "Playback Vocalist" },
      { name: "Priyanka Basnet", role: "Motion Graphics" },
      { name: "Reeta Shakya", role: "Social Impact" },
      { name: "Manoj Karki", role: "Screenings Coordinator" },
    ],
  },

  // ── IN PRODUCTION ────────────────────────────────────────────────
  {
    slug: "valley-of-the-living-gods",
    title: "Valley of the Living Gods",
    nepaliTitle: "जीवित देवताहरूको उपत्यका",
    hindiTitle: "जीवित देवताओं की घाटी",
    genre: "Cultural Fantasy and Heritage Drama",
    year: "2026",
    status: STATUSES.IN_PRODUCTION,
    progress: 65,
    runtime: "126 min (planned)",
    language: "Nepali / Newa",
    poster: POSTERS.festival,
    shortSynopsis: "A cinematic story inspired by Kathmandu Valley's living traditions, sacred festivals, ancient rituals and divine legends.",
    synopsis: "A cinematic story inspired by Kathmandu Valley's living traditions, sacred festivals, ancient rituals and divine legends. Within courtyards where gods still take human form, a child chosen by lineage must decide whether divinity is inheritance or invitation.",
    director: "Manisha Tuladhar",
    writer: "Rohan Malhotra & Bhuwan Acharya",
    dop: "Aarav Iyer",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Manisha Tuladhar", role: "Director" },
      { name: "Rohan Malhotra", role: "Writer" },
      { name: "Bhuwan Acharya", role: "Writer" },
      { name: "Aarav Iyer", role: "Cinematographer" },
      { name: "Bhim Bahadur Gautam", role: "Creative Director" },
      { name: "Kul Bahadur Karki", role: "Production Manager" },
      { name: "Diwas Rai", role: "Music Director" },
      { name: "Aakash Basnet", role: "First Assistant Director" },
      { name: "Sneha Joshi", role: "Costume Designer" },
      { name: "Prashant Thapa", role: "Drone Operator" },
      { name: "Vikas Nair", role: "Production Sound Mixer" },
      { name: "Saraswati Devi", role: "Playback Vocalist" },
      { name: "Anita Ghimire", role: "Publicity & Festivals" },
    ],
  },
  {
    slug: "the-silent-monastery",
    title: "The Silent Monastery",
    nepaliTitle: "मौन गुम्बा",
    hindiTitle: "खामोश मठ",
    genre: "Spiritual Mystery and Psychological Drama",
    year: "2027",
    status: STATUSES.IN_PRODUCTION,
    progress: 45,
    runtime: "120 min (planned)",
    language: "Nepali / Tibetan",
    poster: POSTERS.monastery,
    shortSynopsis: "A filmmaker enters a remote Himalayan monastery and discovers hidden memories, spiritual conflict and an unresolved mystery.",
    synopsis: "A filmmaker enters a remote Himalayan monastery and discovers hidden memories, spiritual conflict and an unresolved mystery. Behind a vow of silence, a truth waits — patient as prayer flags, sharp as the edge of a bell.",
    director: "Sushil K C",
    writer: "Anmol Bhave",
    dop: "Bijay Limbu",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Sushil K C", role: "Director" },
      { name: "Anmol Bhave", role: "Writer" },
      { name: "Bijay Limbu", role: "Cinematographer" },
      { name: "Kul Bahadur Karki", role: "Production Manager" },
      { name: "Bhuwan Acharya", role: "Story Consultant" },
      { name: "Nabin Subedi", role: "Second Assistant Director" },
      { name: "Suraj Tamang", role: "Production Coordinator" },
      { name: "Bikash Maharjan", role: "Set Decorator" },
      { name: "Dinesh Rai", role: "Steadicam Operator" },
      { name: "Prajwal Shrestha", role: "Sound Designer" },
      { name: "Nirmal Gurung", role: "Boom Operator" },
      { name: "Aditi Bhattacharya", role: "Editor" },
      { name: "Ishaan Bhandari", role: "Assistant Editor" },
    ],
  },
  {
    slug: "fire-beneath-the-snow",
    title: "Fire Beneath the Snow",
    nepaliTitle: "हिउँमुनिको आगो",
    hindiTitle: "बर्फ के नीचे आग",
    genre: "Survival, Social and Mountain Drama",
    year: "2027",
    status: STATUSES.IN_PRODUCTION,
    progress: 30,
    runtime: "130 min (planned)",
    language: "Nepali",
    poster: POSTERS.snow,
    shortSynopsis: "A powerful survival story about a Himalayan community confronting natural danger, displacement and the struggle to protect its homeland.",
    synopsis: "A powerful survival story about a Himalayan community confronting natural danger, displacement and the struggle to protect its homeland. When the mountain begins to speak in landslides, an old woman's refusal to leave becomes the last argument for home.",
    director: "Bikash Rana Magar",
    writer: "Sudip Sharma",
    dop: "Kartik Vijay",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Bikash Rana Magar", role: "Director" },
      { name: "Sudip Sharma", role: "Writer" },
      { name: "Kartik Vijay", role: "Cinematographer" },
      { name: "Kul Bahadur Karki", role: "Production Manager" },
      { name: "Bhim Bahadur Gautam", role: "Creative Director" },
      { name: "Sushil K C", role: "Creative Advisor" },
      { name: "Diwas Rai", role: "Music Director" },
      { name: "Aakash Basnet", role: "First Assistant Director" },
      { name: "Sunil Kumar Sah", role: "Line Producer" },
      { name: "Alisha Karki", role: "Second Unit DoP" },
      { name: "Prajwal Shrestha", role: "Sound Designer" },
      { name: "Aditi Bhattacharya", role: "Editor" },
      { name: "Ishaan Bhandari", role: "Assistant Editor" },
      { name: "Reeta Shakya", role: "Social Impact" },
    ],
  },

  // ── ON THE FLOOR ─────────────────────────────────────────────────
  {
    slug: "pilgrimage-hidden-lake",
    title: "Pilgrimage to the Hidden Lake",
    nepaliTitle: "गुप्त तालको तीर्थयात्रा",
    hindiTitle: "गुप्त झील की तीर्थयात्रा",
    genre: "Adventure, Spirituality and Human Drama",
    year: "2026",
    status: STATUSES.ON_THE_FLOOR,
    location: "Nepal",
    runtime: "118 min (planned)",
    language: "Nepali",
    poster: POSTERS.himalaya,
    shortSynopsis: "A group of travellers undertakes a difficult pilgrimage to a sacred hidden lake, where each person must confront a personal truth.",
    synopsis: "A group of travellers undertakes a difficult pilgrimage to a sacred hidden lake, where each person must confront a personal truth. Altitude thins more than air — it thins the stories we tell ourselves.",
    director: "Kamal Mani Nepal",
    writer: "Priya Malhotra",
    dop: "Ravi Krishnan",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Kamal Mani Nepal", role: "Director" },
      { name: "Priya Malhotra", role: "Writer" },
      { name: "Ravi Krishnan", role: "Cinematographer" },
      { name: "Kul Bahadur Karki", role: "Production Manager" },
      { name: "Sushil K C", role: "Creative Advisor" },
      { name: "Bhuwan Acharya", role: "Story Consultant" },
      { name: "Aakash Basnet", role: "First Assistant Director" },
      { name: "Sunil Kumar Sah", role: "Line Producer" },
      { name: "Meera Pradhan", role: "Location Manager" },
      { name: "Vikas Nair", role: "Production Sound Mixer" },
      { name: "Nirmal Gurung", role: "Boom Operator" },
    ],
  },
  {
    slug: "mask-of-bhairav",
    title: "The Mask of Bhairav",
    nepaliTitle: "भैरवको मुकुन्डो",
    hindiTitle: "भैरव का मुखौटा",
    genre: "Mythological Thriller and Folk Horror",
    year: "2026",
    status: STATUSES.ON_THE_FLOOR,
    location: "Kathmandu Valley",
    runtime: "116 min (planned)",
    language: "Nepali / Newa",
    poster: POSTERS.festival,
    shortSynopsis: "A young photographer becomes connected to an ancient mystery involving Bhairav, forgotten rituals and hidden family secrets.",
    synopsis: "During a sacred masked festival, a young photographer becomes connected to an ancient mystery involving Bhairav, forgotten rituals and hidden family secrets. Beneath the brass and vermilion, something older still asks to be worn.",
    director: "Sameer Prasad Chhetri",
    writer: "Anmol Bhave",
    dop: "Aarav Iyer",
    producers: CORE_PRODUCERS,
    festivals: [],
    cast: [
      { name: "Sameer Prasad Chhetri", role: "Director" },
      { name: "Anmol Bhave", role: "Writer" },
      { name: "Aarav Iyer", role: "Cinematographer" },
      { name: "Bhim Bahadur Gautam", role: "Creative Director" },
      { name: "Kul Bahadur Karki", role: "Production Manager" },
      { name: "Bhuwan Acharya", role: "Story Consultant" },
      { name: "Diwas Rai", role: "Music Director" },
      { name: "Nabin Subedi", role: "Second Assistant Director" },
      { name: "Sunil Kumar Sah", role: "Line Producer" },
      { name: "Suraj Tamang", role: "Production Coordinator" },
      { name: "Dinesh Rai", role: "Steadicam Operator" },
      { name: "Prajwal Shrestha", role: "Sound Designer" },
      { name: "Anita Sharma", role: "Dialogue Writer" },
      { name: "Kavita Rai", role: "Makeup & Hair" },
      { name: "Roshni Yadav", role: "Wardrobe Supervisor" },
    ],
  },
];

export const CONCEPTS = [
  {
    slug: "little-yak-mountain-star",
    title: "The Little Yak and the Mountain Star",
    nepaliTitle: "सानो चौँरी र हिमालको तारा",
    hindiTitle: "छोटा याक और पहाड़ का तारा",
    genre: "Animation, Family and Adventure",
    poster: POSTERS.yak,
    shortSynopsis: "A heartwarming animated adventure about a young Himalayan yak searching for a legendary mountain star while learning courage, friendship and respect for nature.",
    status: STATUSES.CONCEPT,
  },
  {
    slug: "beyond-the-borderline",
    title: "Beyond the Borderline",
    nepaliTitle: "सीमापारिको सपना",
    hindiTitle: "सरहद के पार सपने",
    genre: "Contemporary Social and Migration Drama",
    poster: POSTERS.border,
    shortSynopsis: "An emotional story about migration, family separation, identity and the sacrifices people make while searching for a better future.",
    status: STATUSES.CONCEPT,
  },
];

export const findFilm = (slug) =>
  FILMS.find((f) => f.slug === slug) || CONCEPTS.find((f) => f.slug === slug);

export const filmsByStatus = (status) => FILMS.filter((f) => f.status === status);
